export enum RequestStatus {
  requestSubmitted = 1,
  fragranceProposal = 2,
  expired = 3,
}